<template>
  <div class="name-cell d-flex text-truncate align-center">
    <span
      :class="[itemIcon.icon]"
      class="list-icon" />
    <span>
      <span
        :title="fileName"
        class="item-name text-truncate">
        {{ fileName }}
        <qx-tooltip
          v-if="tooltip"
          target="parent"
          :text="tooltip" />
      </span>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { getByExtension, getByType } from '@/utils/fileIcons.js';
import { getItemName, getFilenameTooltip } from '@/utils/fileName.js';
import { getExtension } from '@/elements/utils.js';
import QxTooltip from '@/elements/QxTooltip';

const subtype = {
  INCOMING: 'incoming',
  OUTGOING: 'outgoing',
  HOMES: 'homes',
  PROJECTS: 'projects',
};

export default {
  components: {
    QxTooltip,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      itemIcon: this.getItemIcon(),
    };
  },
  computed: {
    ...mapGetters({
      getFolderOptions: 'getFoldersTranslateOptions',
    }),
    fileName() {
      return getItemName(this.item, this.getFolderOptions(false));
    },
    tooltip() {
      return getFilenameTooltip(this.item, this.getFolderOptions(true));
    },
  },
  watch: {
    'item.type'() {
      this.itemIcon = this.getItemIcon();
    },
    'item.isPreviousDir'() {
      this.itemIcon = this.getItemIcon();
    },
  },
  methods: {
    getItemIcon() {
      const type = this.item.type;
      const mdata = this.item.metadata;
      if (Boolean(this.item.isPreviousDir)) {
        return getByType('back');
      }
      if (type === 'D') {
        if (mdata && mdata.is_system) {
          if (mdata.subtype === subtype.INCOMING) {
            return getByType('incoming');
          } else if (mdata.subtype === subtype.OUTGOING) {
            return getByType('outgoing');
          } else if (mdata.subtype === subtype.PROJECTS) {
            return getByType('projects');
          } else if (mdata.subtype === subtype.HOMES) {
            return getByType('homes');
          }
        } else if (mdata && mdata.user_home) {
          return getByType('homeFolder');
        } else {
          return getByType('folderOpen');
        }
      } else if (type === 'F') {
        const name = this.item.name,
          curFileType = this.item.ftype || getExtension(name);
        return getByExtension(curFileType);
      } else if (type === 'S') {
        return getByType('sharedFolder');
      } else if (type === 'T') {
        return getByType('trash');
      } else if (type === 'N') {
        return getByType('transparent');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.list-icon {
  color: $icon-grey;
  margin-right: 10px;
}
</style>
